import { render } from "./HomeTabAll.vue?vue&type=template&id=6680e3ce&scoped=true"
import script from "./HomeTabAll.vue?vue&type=script&lang=js"
export * from "./HomeTabAll.vue?vue&type=script&lang=js"

import "./HomeTabAll.vue?vue&type=style&index=0&id=6680e3ce&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6680e3ce"]])

export default __exports__